import {firebaseAuth} from '../../setup/firebase';

/**
 *
 * @returns The firebase token.
 */
export default function getFirebaseToken(): Promise<string> | undefined {
  return firebaseAuth.currentUser ? firebaseAuth.currentUser.getIdToken() : undefined;
}
